import { STATES } from "../data/states";
import { DMAS } from "../data/dmas";

const ALL_GEOS = [...STATES, ...DMAS];

export function searchGeos(query, types = ["state"]) {
  if (!query.trim()) return [];
  const q = query.trim().toLowerCase();
  return ALL_GEOS.filter(
    g => types.includes(g.type) && (g.name.toLowerCase().includes(q) || g.key.toLowerCase().includes(q))
  ).map(g => ({ id: g.key, ...g }));
}

export function fetchGeosByKeys(keys, types = ["state"]) {
  if (!keys.length) return [];
  const keySet = new Set(keys.map(k => String(k)));
  return ALL_GEOS.filter(
    g => types.includes(g.type) && keySet.has(String(g.key))
  ).map(g => ({ id: g.key, ...g }));
}

export function validateZipCode(str) {
  return typeof str === "string" && /^\d{5}$/.test(str);
}

export function parseZipCSV(text) {
  const codes = new Set();
  const lines = (text || "").split(/\r?\n/);
  for (const line of lines) {
    const cells = line.split(/[,;\t]/).map(c => c.trim()).filter(Boolean);
    for (const cell of cells) {
      if (validateZipCode(cell)) codes.add(cell);
    }
  }
  return Array.from(codes);
}

export function buildZipGeoObject(zip, clusivity = "include") {
  return { id: `ZIP:${zip}`, key: zip, name: zip, display_name: zip, type: "zip_code", clusivity };
}
